export const ApiCacheTags: Record<string, string> = {
  REQUIREMENT_LIST: "requirementList",
  DOCUMENT_DETAILS: "documentDetails",
  FAILED_RULES: "failedRules",
  TAGS_LIST: "tagsList",
  TAGS_LIST_BY_SEARCH_TERM: "tagsListBySearchTerm",
  DOCUMENT_TAGS: "documentTags",
  DOCUMENT_LISTS: "documentLists",
  DOCUMENT_LIST: "documentList",
  TAGS_OVERVIEW: "tagsOverview",
  RULES_OVERVIEW: "rulesOverview",
  TOP_TAGS_OVERVIEW: "topTagsOverview",
  TOP_RULES_OVERVIEW: "topRulesOverview",
  RECOMMENDED_TAGS: "recommendedTags",
  USER_LIST: "UserList",
  REQUIREMENT_RECOMMENDED_TAGS: "requirementrecommendedTags",
  CONFIGURATION_LIST: "configurationList",
  TAG_LIBRARY_CONFIGURATIONS: "tagLibraryConfigurations",
  SEARCH_RESULTS: "searchResults",
  KNOWLEDGE_AGENT: "KNOWLEDGE_AGENT"
};
